import React, { useRef, useState } from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface PersonalInfoSectionProps {
  userSelector: any;
  userType: string;
  isUploading: boolean;
  onProfileImageClick: () => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
  userSelector,
  userType,
  isUploading,
  onProfileImageClick,
  fileInputRef,
  onFileSelect,
}) => {
  const { t } = useTranslation("member");

  return (
    <div className="profile-header-card mb-4">
      <div className="d-flex align-items-center">
        <div className="profile-avatar me-4 profile-avatar-hover" style={{ position: "relative", cursor: "pointer" }}>
          <img
            src={
              userType == "member"
                ? userSelector?.user?.profile_image_url ||
                  userSelector?.user?.profile_photo_url ||
                  "/images/user-avatar.jpg"
                : (userSelector as any)?.user?.profile_image_url ||
                  userSelector?.user?.profile_photo_url ||
                  "/images/user-avatar.jpg"
            }
            alt="Profile Avatar"
            className="profile-avatar-img"
            onClick={onProfileImageClick}
            style={{
              opacity: isUploading ? 0.7 : 1,
              transition: "opacity 0.3s ease",
            }}
          />
          <div className="profile-avatar-camera-overlay">
            <i className="fa fa-camera"></i>
          </div>
          {isUploading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "#007bff",
                fontSize: "20px",
              }}
            >
              <i className="fa fa-spinner fa-spin"></i>
            </div>
          )}
          <input type="file" ref={fileInputRef} style={{ display: "none" }} accept="image/*" onChange={onFileSelect} />
        </div>
        <div className="profile-basic-info flex-grow-1">
          <h2 className="profile-name mb-1">
            {userType == "member" ? userSelector?.user?.name : userSelector?.company?.name || ""}
          </h2>
          <p className="profile-designation mb-3">{userType == "member" ? userSelector?.user?.designation : ""}</p>
        </div>
        <div className="profile-contact-info">
          <div className="contact-item mb-2">
            <span className="contact-label">{t("members.profile.viewProfile.contactInfo.phoneNumber")}</span>
            <span className="contact-value ms-2">
              {userSelector?.user?.phone_code && userSelector?.user?.phone
                ? `${userSelector?.user?.phone_code} ${userSelector?.user?.phone}`
                : t("members.profile.personalInfo.notProvided")}
            </span>
          </div>
          <div className="contact-item">
            <span className="contact-label">{t("members.profile.viewProfile.contactInfo.email")}</span>
            <span className="contact-value ms-2">
              {userSelector?.user?.email || t("members.profile.personalInfo.notProvided")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoSection;
